import styled from 'styled-components';
import { acceptgreen, darkgrey, noticeWarning, white } from 'styles/Colors';

export const SyncBarWrapper = styled.div`
  display: flex;
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.08);
  background-color: ${white};
`;

export const Faq = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: 46px;
  font-family: Lato;
  font-size: 15px;
  letter-spacing: 0.5px;
  color: ${darkgrey};
  font-weight: 700;
`;

export const FaqLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

export const SyncContextualData = styled.div`
  display: flex;
  margin-left: 18px;
  align-items: center;
  font-family: Lato;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: ${darkgrey};
`;

export const Control = styled.div`
  margin-left: 20px;
  text-decoration: underline;
  cursor: pointer;
`;

export const Indicator = styled.div`
  margin-right: 3px;
  &.updating {
    margin-right: 10px;
    height: 39px;
  }
  &.ok {
    svg {
      path {
        fill: ${acceptgreen};
      }
    }
  }
  &.old {
    svg {
      path {
        fill: ${noticeWarning};
      }
    }
  }
`;
